var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1312.44 788.98)",
    id: "9rmF6GM9QaG7cE4tP2C6a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0.000005, 0)",
    d: "M -13.7375 -10 L 26.2625 -10 L 26.2625 10 L -26.262510000000002 10",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 150.05 149.25)",
    id: "LDXGtmqjCeuDiWUH4z8gN"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(106,108,153)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -120.00027 60 L -40.00027 -100 L -0.25027000000000044 -20.5 L 59.46081 -20.5 L 80.00027 -60 L 100.00027 -60 L 79.21081000000001 -20 L 120.00027 -20 L 120.00027 0 L 69.21081000000001 0 L 39.605270000000004 59.21108 L 20.000270000000004 100 L 0.00027000000000398927 100 L 20.000270000000004 60 L -10.289189999999994 0 L -70.00027 0 L -100.00027 60 z M -60.12527 -19.75 L -20.164189999999998 -19.75 L -40.144729999999996 -59.71108 z M 49.56637 0 L 9.62473 -0.75 L 29.60527 39.21108 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 96.25 129.75)",
    id: "pM45OEdaf8FBiKlerbJHl"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 209.68 169.75)",
    id: "NnQiiYCkk_ygQavxCpfSw"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(254,96,81)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -59.87724 -40.5 L -0.16615999999999786 -40.5 L 20.3733 -80 L 40.3733 -80 L 19.583840000000002 -40 L 60.3733 -40 L 60.3733 -20 L 9.583840000000002 -20 L -20.0217 39.21108 L -39.6267 80 L -58.31558 80 L -19.882169999999995 -0.7067499999999995 L -10.060599999999996 -20 L -10.688899999999995 -20.0118 L -10.437859999999995 -20.53896 L -51.37329999999999 -20 L -60.37329999999999 -41.49213 z M -59.6267 80 L -59.21336 79.17331 L -58.84079 80 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 150.05 135.75)",
    id: "LCJtvKgVe46uFDJS5Wxkg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(184,225,243)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -34.625 -89.5 L 5.125 -10 L 84.375 -10 L 34.625 89.5 L -5.125 10 L -84.375 10 z M 15.125 10 L 14.875 10 L 34.625 49.5 L 54.75 9.25 L 14.75 9.25 z M -34.625 -49.5 L -54.75 -9.25 L -14.75 -9.25 L -15.125 -10 L -14.875 -10 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d184b51c8d45ccef19c6552d95d3f351.svg";
export { ForwardRef as ReactComponent };